import { BreadcrumbItem } from "../models/miscellaneous";

export const CustomerBreadCrumbItem: BreadcrumbItem[] = [
  {
    label: "Dashboard",
    href: "/",
  },
  {
    label: "My Customers",
  },
];

export const CreateCartBreadCrumbItem = (
  customerId: string,
  customerName?: string
): BreadcrumbItem[] => [
    {
      label: "Dashboard",
      href: "/",
    },
    {
      label: "Customers",
      href: "/customer",
    },
    {
      label: customerName || "Customer Detail",
      href: `/customer/detail/${customerId}`,
    },
    {
      label: "Create Cart", // last one has no href
    },
  ];

export const CartDetailBreadCrumbItem = (
  customerId: string,
  customerName?: string
): BreadcrumbItem[] => [
    {
      label: "Dashboard",
      href: "/",
    },
    {
      label: "Customers",
      href: "/customer",
    },
    {
      label: customerName || "Customer Detail",
      href: `/customer/detail/${customerId}`,
    },
    {
      label: "Cart Detail",
    },
  ];

export const MyProfileBreadCrumbItem: BreadcrumbItem[] = [
  {
    label: 'Dashboard',
    href: "/",
  },
  {
    label: "My Profile"
  }
]